import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ApiService, Faq } from '../../services/api.service';

@Component({
  selector: 'app-finance',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './finance.component.html'
})
export class FinanceComponent implements OnInit {
  faqs: Faq[] = [];

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    // Try to load FAQs from backend, fall back to offline data
    this.api.getFaqs('Finance').subscribe({
      next: (data) => {
        if (data && data.length > 0) {
          this.faqs = data;
        } else {
          this.loadFallbackFaqs();
        }
      },
      error: () => this.loadFallbackFaqs()
    });
  }

  private loadFallbackFaqs(): void {
    this.faqs = [
      { id: 1, question: 'How does ZAD ERP automate the Chart of Accounts?', answer: 'ZAD ERP uses a multidimensional architectural hierarchy. When you set up your organizational structure, the system intelligently maps accounts based on your business model, ensuring every asset, liability, and equity group is automatically linked to its corresponding ledger entries.', module: 'Finance', sortOrder: 1 },
      { id: 2, question: 'Can I manage multiple bank accounts and currencies?', answer: 'Yes. The Treasury & Liquidity engine allows for seamless management of multiple bank interfaces and provides a unified view of all cash positions. The system handles real-time currency conversions and cross-border transactions with precise exchange rate tracking.', module: 'Finance', sortOrder: 2 },
      { id: 3, question: 'Is the tax engine compliant with local VAT regulations?', answer: 'Absolutely. Our Tax & Compliance engine is designed to automate regional and international tax configurations. You can define specific tax rules for different jurisdictions, and the system will automatically apply them to all journals and invoices, ensuring 100% regulatory compliance.', module: 'Finance', sortOrder: 3 },
      { id: 4, question: 'How do automated journals work between Sales and Accounting?', answer: 'ZAD ERP utilizes Zero-Touch Bookkeeping. Every transaction processed in the Sales or Rental modules is instantly mirrored into the General Ledger using precise double-entry logic. This eliminates manual entry errors and ensures that your books are always audit-ready.', module: 'Finance', sortOrder: 4 },
      { id: 5, question: 'Does the reporting center provide real-time Balance Sheets?', answer: 'Yes. The Advanced Reporting Center offers real-time financial intelligence. You can generate consolidated Balance Sheets, Profit & Loss statements, and Cash Flow reports at any moment, providing a live diagnostic check of your business\'s financial health.', module: 'Finance', sortOrder: 5 }
    ];
  }
}
